import { getCssVar } from "../../types/theme.ts";

export const GreenCheck2 = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="check-mark (4) 1" clipPath="url(#clip0_3736_2617)">
      <path
        id="Vector"
        d="M23.6 12.1879C23.6 18.8407 18.004 24.1827 11.2608 23.7651C5.48321 23.4071 0.780806 18.7047 0.423206 12.9271C0.00520572 6.18389 5.34721 0.587891 12 0.587891C13.8272 0.587891 15.5572 1.00949 17.096 1.76429C17.5084 1.96669 17.6596 2.48029 17.432 2.87949L17.4304 2.88229C17.22 3.25109 16.7608 3.38829 16.38 3.20069C14.8528 2.44869 13.1068 2.08269 11.264 2.21429C6.42401 2.55949 2.47121 6.44149 2.04041 11.2747C1.50441 17.2903 6.32521 22.3395 12.2656 22.1843C17.3528 22.0515 21.5992 18.0171 21.9716 12.9419C22.0684 11.6235 21.9096 10.3471 21.532 9.17029C21.4124 8.79709 21.5864 8.39429 21.9368 8.21909C22.3744 8.00029 22.9108 8.21909 23.0592 8.68509C23.4104 9.78949 23.6 10.9663 23.6 12.1879Z"
        fill={getCssVar("color_checklist_icon")}
      />
      <path
        id="Vector_2"
        d="M6.16401 9.17668L12.4896 17.7355C12.9672 18.3819 13.9392 18.3259 14.342 17.6291L23.4828 1.80588C23.9588 0.981884 22.8728 0.153484 22.2252 0.847084L12.702 11.0479L7.17641 7.98948C6.42961 7.57628 5.65361 8.48588 6.16401 9.17668Z"
        fill={getCssVar("color_checklist_icon")}
      />
    </g>
    <defs>
      <clipPath id="clip0_3736_2617">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.187988)"
        />
      </clipPath>
    </defs>
  </svg>
);
